var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"p-2",style:(_vm.skin.my_account.menu_item_border)},[_c('h5',[_vm._v(_vm._s(_vm.user_data.nombre))])]),_c('records',{attrs:{"skin":_vm.skin,"language":_vm.language,"translation":_vm.translation,"user_id":_vm.user_data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }